const mono = {
  100: 'hsl(0, 0%, 10%)',
  500: 'hsl(0, 0%, 40%)',
  900: 'hsl(0, 0%, 97%)',
};

export default {
  mono,
};
